import React, { memo } from 'react';
import Div from '@/shared/Div';
import Container from '@/shared/Container';
import Heading from '@/shared/Heading';
import Paragraph from '@/shared/Paragraph';
import Map from '@/components/Map';
import withContentFlags from '@/hoc/withContentFlags';
import ArrowForward from '@/components/Icons/ArrowForward';
import RightArrow from '@/components/Icons/RightArrow';
import LeftArrowIcon from '@/components/Icons/LeftArrow';

interface LinkItem {
  id: number;
  label: string;
  href: string | null;
  target: string;
  theme: string;
  size: string;
}

export interface CorporateGovernanceProps {
  title: string;
  list: LinkItem[];
}

const CorporateGovernance = (props: CorporateGovernanceProps) => {
  const { title, list = [] } = props;

  const renderLinkCard = (item: LinkItem, index: number) => {
    const { label, href, target } = item;

    const content = (
      <>
        <LeftArrowIcon
          className="rotate-180 text-cti-primary group-hover:rotate-[135deg] transition-all group-hover:text-cti-on-primary "
          fill="currentColor"
        />
        <Paragraph className="text-body-lg text-cti-primary group-hover:text-cti-on-primary font-normal transition-all">
          {label}
        </Paragraph>
      </>
    );

    const cardClasses =
      'group flex items-center gap-3 p-6 bg-white hover:bg-cm-brand rounded-2xl border border-gray-200 w-full transition-colors cursor-pointer';

    if (href) {
      return (
        <a
          key={index}
          href={href}
          target={target}
          rel={target === '_blank' ? 'noopener noreferrer' : undefined}
          className={cardClasses}
        >
          {content}
        </a>
      );
    }

    return (
      <Div key={index} className={cardClasses}>
        {content}
      </Div>
    );
  };

  return (
    <Div className="bg-cs-secondary py-7 md:py-20">
      <Container className="flex flex-col gap-s7">
        <Heading level="2" className="text-hd-1 md:text-desktop-h-1 text-cm-brand">
          {title}
        </Heading>

        {/* Links Grid */}
        <Div className="flex flex-col gap-s6 md:grid md:grid-cols-2 lg:grid-cols-3">
          <Map list={list} render={renderLinkCard} />
        </Div>
      </Container>
    </Div>
  );
};

export default withContentFlags(memo(CorporateGovernance));
